// export const GoogleMapsAPI = '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';
export const GoogleMapsAPI = process.env.REACT_APP_GOOGLE_MAP_KEY;
// export const GoogleMapsAPI = 'AIzaSyDKjQUy_qz9i57KPW-da_9BV849mnxn4hg';
